import { createContext } from "react";
import type { TenantBranding } from "@/lib/branding/types";

export type BrandingContextValue = {
  branding: TenantBranding | null;
  loading: boolean;
  reload: () => void;
};

export const BrandingContext = createContext<BrandingContextValue>({
  branding: null,
  loading: true,
  reload: () => {},
});
